export enum DocumentEntity {
  Attach = 'FaxAction Attach',
  None = '',
  Upload = 'Upload'
}
